// Calculate bounds to fit all markers with valid coordinates
import { MapBounds, MapMarker } from "./types";

const calculateBounds = (markers: MapMarker[]): MapBounds => {
    const validMarkers = markers.filter(marker =>
        marker.latitude && marker.longitude
    );
    if (validMarkers.length === 0) {
        return {
            north: 20,
            south: -50,
            east: -130,
            west: 110,
        };
    }

    // Extract coordinates
    const coordinates = validMarkers.map(marker => ({
        lat: marker.latitude,
        lng: marker.longitude
    }));

    // Check if coordinates cross the International Date Line
    const lngs = coordinates.map(coord => coord.lng);
    const minLng = Math.min(...lngs);
    const maxLng = Math.max(...lngs);
    const crossesDateLine = maxLng - minLng > 180;

    // Adjust longitudes if crossing date line
    if (crossesDateLine) {
        coordinates.forEach(coord => {
            if (coord.lng < 0) {
                coord.lng += 360; // Shift negative longitudes
            }
        });
    }

    // Calculate bounds
    const bounds = coordinates.reduce(
        (acc, coord) => {
            return {
                north: Math.max(acc.north, coord.lat),
                south: Math.min(acc.south, coord.lat),
                east: Math.max(acc.east, coord.lng),
                west: Math.min(acc.west, coord.lng),
            };
        },
        { north: -90, south: 90, east: -180, west: 180 }
    );

    const padding = 0.1;

    // Convert back if we adjusted for date line crossing
    if (crossesDateLine) {
        return {
            north: bounds.north + padding,
            south: bounds.south - padding,
            east: bounds.east > 180 ? bounds.east - 360 + padding : bounds.east + padding,
            west: bounds.west > 180 ? bounds.west - 360 - padding : bounds.west - padding,
        };
    }

    return {
        north: bounds.north + padding,
        south: bounds.south - padding,
        east: bounds.east + padding,
        west: bounds.west - padding,
    };
};

export { calculateBounds };